import { createStore, compose, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'
import reducer from './../modules/index'

export const configure = (history, initialState = {}) => (
  createStore(
    reducer,
    initialState,
    compose(
      applyMiddleware(thunk),
      window.__REDUX_DEVTOOLS_EXTENSION__ && process.env.NODE_ENV !== 'production' ? window.__REDUX_DEVTOOLS_EXTENSION__() : f => f
    )
  )
)

export default configure()



// WEBPACK FOOTER //
// ./src/store/configureStore.js